import { useMedia } from 'use-media';
import { mobileBreakpoint, smallMobileBreakpoint } from '../modules/theme';

const mediaQueryCond = `(max-width: ${mobileBreakpoint}px)`;
const mediaQuerySmallCond = `(max-width: ${smallMobileBreakpoint}px)`;

export const useIsMobile = () => useMedia(mediaQueryCond);
export const useIsSmallMobile = () => useMedia(mediaQuerySmallCond);
